import { cacheTypes, getMethodByCallBack, getheader, postMethod, postMethodByCallBack, serverUrl, setErrorDialog, translateError } from "./CommonFunctions";

export function GetAllProduct() {
  return dispatch => {
    fetch(serverUrl + "ReceptionTasksAPI/GetProductNames/")
      .then(res => res.json())
      .then(res => {
        return dispatch({
          type: "FETCH_DATA_PRODUCT",
          data: res
        })
      }
      ).catch(err => console.error('[FETCH_DATA_PRODUCT]', err));
  };
}

export function getProductInfoBySerialOrCode(data, onProductFound) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrBarCode?serialAndBarCode=" + data, {
      headers: getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        onProductFound(res);
        // dispatch({
        //   type: "FETCH_PRODUCT_BY_QRCODE",
        //   data: res
        // })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}
export function getProductBySerialOrGuaranteeCard(data) {
  if (!data || data === '') {
    alert("مقداری برای جستجو وجود ندارد");
    return;
  }
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrGuaranteeCard?serialOrCardNo=" + data, {
      headers: getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFound") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        dispatch({
          type: "FETCH_PRODUCT_BY_QRCODE",
          data: res
        })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}

export function setQrPopupStatus(status) {
  return dispatch => {
    return dispatch({
      type: "SET_QRPOPUP_STATUS",
      data: status
    });
  }
}
export function setProductPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_PRODUCT_POPUP",
      data: status
    });
  }
}
export function setDialog(status) {
  return dispatch => {
    return dispatch({
      type: "SET_DIALOG",
      data: status
    });
  }
}
export function searchProductForSelect(data, onGetData) {
  return dispatch => {
    if (!onGetData) {
      dispatch({
        type: "SEARCH_PRODUCT_SELECT",
        data: "PENDING"
      })
    }

    fetch(serverUrl + `api/ProductAPI/SearchProductForSelect`, {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFound" || res === "FillSearchFields" || res.Message === "Error") {
            const msg = res.Message ?? res;
            res = {};
            res.Error = translateError(msg);
          }
        }
        if (onGetData) {
          onGetData(res);
        }
        else {
          dispatch({
            type: "SEARCH_PRODUCT_SELECT",
            data: res
          })
        }
      }).catch(e => {
        if (onGetData) {
          onGetData([]);
        }
        else {
          dispatch({
            type: "SEARCH_PRODUCT_SELECT",
            data: []
          });
        }
        console.log("[SEARCH_PRODUCT_SELECT]", e)
      });
  }
}
export function searchUsedParts(data, onGetData) {
  onGetData("PENDING");
  fetch(serverUrl + `api/ProductAPI/SearchUsedParts`, {
    headers: getheader(),
    method: "POST",
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(res => {
      if (res === "ProductNotFount") {
        onGetData({ Error: "کالایی با این مشخصات یافت نشد" });
        return;
      }
      else if (res.Message === "Error") {
        onGetData({ Error: "اشکال در دریافت کالاها" })
        return;
      }
      onGetData(res);
    }).catch(e => console.log("[SEARCH_USED_PARTS]", e));
}
export function searchUsedPartsProduction(data, mainProductHardCode, onGetData) {
  onGetData("PENDING");
  fetch(serverUrl + `api/ProductAPI/SearchUsedPartsProduction?mainProductHardCode=${mainProductHardCode}`, {
    headers: getheader(),
    method: "POST",
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(res => {
      if (res === "ProductNotFount") {
        onGetData({ Error: "کالایی با این مشخصات یافت نشد" });
        return;
      }
      else if (res.Message === "Error") {
        onGetData({ Error: "اشکال در دریافت کالاها" })
        return;
      }
      onGetData(res);
    }).catch(e => console.log("[SEARCH_USED_PARTS]", e));
}
export function searchProducts4Invoice(data, onGetData) {
  return dispatch => {
    fetch(serverUrl + `api/ProductAPI/SearchProducts4Invoice`, {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res.Message) {
            const msg = translateError(res.Message);
            onGetData({ Error: msg });
            return;
          }
        }
        if (onGetData) {
          onGetData(res);
        }
        else {
          dispatch({
            type: "SEARCH_PRODUCT_SELECT",
            data: res
          })
        }
      }).catch(e => console.log("[searchProducts4Invoice]", e));
  }
}
export async function searchProducts4InvoiceAsync(data, onGetData) {
  const result = await postMethod("api/ProductAPI/SearchProducts4Invoice", data, "SearchProducts4Invoice");
  return result;
}
export function searchBorrowPorductsForUsedParts(data, onGetData) {
  postMethodByCallBack(`api/ProductAPI/SearchBorowProductsForUsedParts`, data, onGetData, "SearchBorowProductsForUsedParts");
}
export function searchProducts4StorageReports(data, onGetData) {
  postMethodByCallBack(`api/ProductAPI/SearchProducts4StorageReports`, data, onGetData, "SearchProducts4StorageReports");
}

export function getProductInfoFromModal(res) {
  return dispatch => dispatch({
    type: "PRODUCT_INFO_FROM_MODAL",
    data: res
  })
}
export function resetProductQRCode() {
  return dispatch => {
    return dispatch({
      type: "FETCH_PRODUCT_BY_QRCODE",
      data: ""

    });
  }
}
export function setProductBugPop(status) {
  return dispatch => {
    return dispatch({
      type: "SET_PBUG_POP",
      data: status
    });
  }
}
export function searchProductBug(data) {
  return dispatch => {
    dispatch({
      type: "SEARCH_PRODUCT_BUG",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductBugAPI/SearchProductBug", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || (res.Message && (res.Message.search("error") || res.Message === "Error"))) {
          setErrorDialog(dispatch, res?.Message??res, "فهرست ایراد");
          res = null;
        }
        return dispatch({
          type: "SEARCH_PRODUCT_BUG",
          data: res
        });
      }).catch(e => {
        console.log("[SEARCH_PRODUCT_BUG]", e);
        return dispatch({
          type: "SEARCH_PRODUCT_BUG",
          data: null
        });
      })
  }
}
export function setAccessoriesPop(status) {
  return dispatch => {
    return dispatch({
      type: "SET_ACCESSORIES_POP",
      data: status
    });
  }
}
export function loadProductAccessories(data) {
  return dispatch => {
    dispatch({
      type: "LOAD_PRODUCT_ACCESSORIES",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductAPI/LoadProductAccessories", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data),
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          alert("بازیابی لیست لوازم همراه با مشکل مواجه شد");
          res = null;
        }
        return dispatch({
          type: "LOAD_PRODUCT_ACCESSORIES",
          data: res
        });
      }).catch(e => {
        console.log("[LOAD_PRODUCT_ACCESSORIES]", e);
        return dispatch({
          type: "LOAD_PRODUCT_ACCESSORIES",
          data: null
        });
      })
  }
}
export function addOrUpdateProduct(data, fn) {
  postMethodByCallBack("api/ProductAPI/AddOrUpdateProduct", data, fn, "AddNewProduct");
}
export function getLastCode(setCode) {
  getMethodByCallBack("api/ProductAPI/GetLastCode", cacheTypes.NoCache, setCode, "GetLastCode");
}
export function getAllProductTypes() {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCT_TYPES",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductAPI/GetAllProductTypes", {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "GET_PRODUCT_TYPES",
          data: res
        })
      })
  }
}

export function getAllProductHolders(type, onGet) {
  postMethodByCallBack("api/GuarantyHolderAPI/GetAllProductHolder", type, onGet, "GET_PRODUCT_HOLDERS");
}
export function getAllProductTypesNew(onGet) {
  getMethodByCallBack("api/ProductTypeAPI/GetAllProductTypes", cacheTypes.NoCache, onGet, "GetAllProductTypes");
}
export function getProductGroups4Select(name, onGet) {
  getMethodByCallBack(`api/ProductAPI/GetProductGroups4Select?name=${name}`, cacheTypes.NoCache, onGet, "GetProductGroups4Select");
}
export function getAllProductMainGroups(onGet) {
  getMethodByCallBack("api/ProductGroupingAPI/GetAllProductMainGroups", cacheTypes.NoCache, onGet, "GetAllProductMainGroups");
}
export function getProductGroups(mainGroupID, onGet) {
  return getMethodByCallBack(`api/ProductGroupingAPI/GetProductGroups?mainGroupID=${mainGroupID}`, cacheTypes.NoCache, onGet, "GetProductGroups");
}

